import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../pages/SurveyStart.scss';

export default function SurveySponsors({ id, details, setStart, setCurrentPage, startSurvey, handleStartSurveyForDetails }) {
  const navigate = useNavigate();
  const language = localStorage.getItem('language') || 'English';

  const texts = {
    English: {
      attention: 'Attention!',
      warning: 'Please do not exit or refresh this page during the survey. If you do, you will lose your progress and be redirected to the survey page.',
      ensure: 'Make sure to complete the survey in one session to ensure your responses are recorded.',
      sponsoredBy: 'Survey Sponsored By',
      start: 'Start',
      cancel: 'Cancel'
    },
    Italian: {
      attention: 'Attenzione!',
      warning: 'Si prega di non uscire o aggiornare questa pagina durante il sondaggio. Se lo fai, perderai i tuoi progressi e dovrai cominciare da capo.',
      ensure: 'Assicurati di completare il sondaggio in un\'unica sessione per garantire che le tue risposte vengano registrate.',
      sponsoredBy: 'Sondaggio Sponsorizzato Da',
      start: 'Inizia',
      cancel: 'Annulla'
    }
  };

  const handleCancel = () => {
    navigate(`/survey-details/${id}`);
    handleStartSurveyForDetails();
  };

  return (
    <>
      {
        startSurvey && <>
          <div className="container">
            <div className="alert alert-warning" role="alert">
              <h4 className="alert-heading">{texts[language].attention}</h4>
              <p>{texts[language].warning}</p>
              <hr />
              <p className="mb-0">{texts[language].ensure}</p>
            </div>
          </div>
        </>
      }
      <div className="title">
        {
          details?.sponsors?.length > 0 && (
            <button onClick={() => navigate(-1)}>
              <img src={`${process.env.PUBLIC_URL}/images/survey/back.png`} alt="back" /> {texts[language].sponsoredBy}
            </button>
          )
        }
      </div>
      <div className="sponser_wrapper" style={{
        padding: '15px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <div className="row" style={{
          display: 'flex',
          flexWrap: 'wrap',
          margin: '0 -10px'
        }}>
          {details?.sponsors?.map((detail, index) => (
            <div key={index} className="col-md-6" style={{
              padding: '10px',
              width: '100%',
              '@media (min-width: 768px)': {
                width: '50%'
              }
            }}>
              <div className="sponser_card" style={{
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                overflow: 'hidden',
                transition: 'transform 0.2s',
                cursor: 'pointer',
                ':hover': {
                  transform: 'translateY(-3px)'
                }
              }}>
                <div className="card_image" style={{
                  width: '100%',
                  height: '140px',
                  overflow: 'hidden'
                }}>
                  <img
                    src={`https://votiamo-image.s3.ap-south-1.amazonaws.com/${detail.image}`}
                    alt=""
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </div>
                <div className="card_contnet" style={{
                  padding: '12px'
                }}>
                  <div className="card_title" style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#333',
                    marginBottom: '6px'
                  }}>
                    {detail.name.length > 30 ? detail.name.substring(0, 30) + '...' : detail.name}
                  </div>
                  <a
                    className="card_link"
                    href={detail.link}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: '#0066cc',
                      textDecoration: 'none',
                      fontSize: '13px',
                      ':hover': {
                        textDecoration: 'underline'
                      }
                    }}
                  >
                    {detail.link.length > 30 ? detail.link.substring(0, 30) + '...' : detail.link}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="action">
        <button onClick={() => { setStart(true); setCurrentPage(1); }}>{texts[language].start}</button>
        <button className="cancel" onClick={() => { handleCancel() }}>{texts[language].cancel}</button>
      </div>
    </>
  );
}
